import { type LDContext } from 'launchdarkly-react-client-sdk';

const LAUNCH_DARKLY_CONTEXT_DEFAULTS = {
  kind: 'user',
  appVersion: process.env.APP_VERSION,
  platform: 'web',
} as const;

const CLEARED_ANONYMOUS_USER_ATTRIBUTES = {
  email: null,
  firstName: null,
  lastName: null,
} as const;

export const mergeLaunchDarklyIdentifyContext = (previous: LDContext | undefined, next: LDContext): LDContext => {
  if (next.anonymous === true) {
    return {
      ...LAUNCH_DARKLY_CONTEXT_DEFAULTS,
      ...next,
      ...CLEARED_ANONYMOUS_USER_ATTRIBUTES,
    };
  }

  return {
    ...LAUNCH_DARKLY_CONTEXT_DEFAULTS,
    ...previous,
    ...next,
  };
};
